import React, { useState } from "react";
import { Input } from "@headlessui/react";
import { EyeIcon, EyeSlashIcon } from "@heroicons/react/24/outline";
import "./Password.css";

export default function Password(props: {
	id: string;
	name: string;
	className: string;
	value: string;
	required?: boolean;
	readonly?: boolean;
	minLength?: number;
	maxLength?: number;
	placeholder?: string;
	autoComplete?: string;
	onChange?: (e: React.ChangeEvent<HTMLInputElement>) => void;
	onInput?: (e: React.FormEvent<HTMLInputElement>) => void;
}) {
	const [showPassword, setShowPassword] = useState(false);

	const handleClickShowPassword = () => {
		setShowPassword(!showPassword);
	};

	const handleMouseDownPassword = (event: React.MouseEvent) => {
		event.preventDefault();
	};

	return (
		<div className="Password relative">
			<Input
				type={showPassword ? "text" : "password"}
				name={props.name}
				id={props.id}
				className={`${props.className ?? ""} pr-10`}
				placeholder={props.placeholder ?? "password"}
				required={props.required}
				readOnly={props.readonly}
				autoComplete={props.autoComplete ?? "current-password"}
				minLength={props.minLength}
				maxLength={props.maxLength}
				onChange={(e) => (props.onChange ? props.onChange(e) : null)}
				onInput={(e) => (props.onInput ? props.onInput(e) : null)}
				value={props.value}
			/>
			<div className="absolute right-3 top-2">
				{showPassword ? (
					<EyeIcon
						className="h-5 w-5 text-gray-400"
						aria-hidden="true"
						onClick={handleClickShowPassword}
						onMouseDown={handleMouseDownPassword}
					/>
				) : (
					<EyeSlashIcon
						className="h-5 w-5 text-gray-400"
						aria-hidden="true"
						onClick={handleClickShowPassword}
						onMouseDown={handleMouseDownPassword}
					/>
				)}
			</div>
		</div>
	);
}
